import { AsyncActionStatus, IAsyncAction } from '../AsyncAction';
import { ILevelState, initialLevelState } from '../Level/ILevelState';
import { initialPlayerState, IPlayerState } from '../Player/IPlayerState';
import {
    initialUIState,
    initialUIStatePrio,
    IUIState,
    IUIStatePrio,
} from '../UI/IUIState';
import { initialUserState, IUserState } from '../User/IUserState';
import { initialWorldState, IWorldState } from '../World/IWorldState';
import { EntryPoint } from './EntryPoint/GameEntryPoint';
import { IContext, initialContext } from './IContext';
import { initialPlatformState, IPlatformState } from './IPlatformState';
import IPlayerData from '../../Player/IPlayerData';

export enum GameScene {
    WORLD = 'World',
    LEVEL = 'Level',
}

export const initialGameState: IGameState = {
    gamePaused: false,
    gameLoaded: false,
    context: initialContext,
    entryPoint: null,
    levelState: initialLevelState,
    worldState: initialWorldState,
    platform: initialPlatformState,
    UIState: initialUIState,
    UIStatePrio: initialUIStatePrio,
    userState: initialUserState,
    playerState: initialPlayerState,
    activeScene: {
        status: AsyncActionStatus.EMPTY,
        result: null,
    },
    dataConflict: {
        status: AsyncActionStatus.EMPTY,
        result: null,
    },
    previousState: null,
};

export interface IGameState {
    gamePaused: boolean;
    gameLoaded: boolean;

    /**
     * Default game context or external overlay context.
     */
    context: IContext;

    /**
     * Data associated with various game entry points (messages, payloads, friends, etc.).
     */
    entryPoint: EntryPoint;

    levelState: ILevelState;

    worldState: IWorldState;

    UIState: IUIState;

    UIStatePrio: IUIStatePrio;

    platform: IPlatformState;

    /**
     * Data associated with the user's current session.
     */
    userState: IUserState;

    /**
     * Data associated with the player that is saved across multiple game sessions.
     * TODO: Some values in playerState are not persisted and should be moved to userState.
     */
    playerState: IPlayerState;

    /**
     * The current 'active' scene (not including 'passive' scenes i.e. preloading).
     */
    activeScene: IAsyncAction<GameScene>;

    /**
     * The current data conflicts.
     */
    dataConflict: IAsyncAction<IPlayerData[]>;

    /**
     * A copy of the previous state for transitional information.
     */
    previousState: IGameState;
}
